module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-17.3a49d4fb.png";